<div class="content__wrapper">
  @if (!isLoginPage) {
    <app-nav-menu
      [env]="environment"
      [userToken]="userToken"
      [firstName]="userLite?.firstName || ''"
      [lastName]="userLite?.lastName || ''"
      [isLoggedIn]="isLoggedIn"
      appTitle="Sierra User"
      (logout)="onLogout()"
      [menuItems]="menuItems"
      [sites]="sites"
      [selectedSiteId]="selectedSiteId"
      (siteChanged)="onSiteChanged($event)"
    />
  }
  <div class="cs-shell">
    @if (!isLoginPage) {
      <csl-main-header />
    }
    <router-outlet></router-outlet>
  </div>
  <p-toast position="bottom-right" key="main" />
</div>
<csl-environment-indicator [envType]="environment" />
